import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CursorGlow() {
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 60, damping: 20 });
  const sy = useSpring(y, { stiffness: 60, damping: 20 });

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const move = (e) => {
      x.set(e.clientX - 250);
      y.set(e.clientY - 250);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      aria-hidden="true"
      style={{
        x: sx,
        y: sy,
        background: "radial-gradient(circle, rgba(99,102,241,0.16) 0%, transparent 60%)",
      }}
      className="pointer-events-none fixed top-0 left-0 z-[5] h-[500px] w-[500px] rounded-full mix-blend-screen hidden md:block"
    />
  );
}
